export default __webpack_public_path__ + "static/media/Century-Schoolbook-Std-Regular.1cadf81a.woff";